import { isEqual, mapValues } from 'lodash-es'

import { ActionableState, useActionableState } from './useActionableState'

export enum SortKeys {
  SORT_BY = 'sortBy',
  SORT_DIRECTION = 'sortDirection',
}

export enum SortBy {
  ID = '_id_num',
  DELIVERY_DATE = '_delivery_date',
  PICKUP_DATE = '_pickup_date',
}
type SortByState = ActionableState<SortBy>

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}
type SortDirectionState = ActionableState<SortDirection>

export type SortValues = {
  [SortKeys.SORT_BY]: SortBy
  [SortKeys.SORT_DIRECTION]: SortDirection
}

const defaultValues: SortValues = {
  [SortKeys.SORT_BY]: SortBy.ID,
  [SortKeys.SORT_DIRECTION]: SortDirection.DESC,
}

export type Sort = {
  [SortKeys.SORT_BY]: SortByState
  [SortKeys.SORT_DIRECTION]: SortDirectionState
}

type SortState = {
  sort: Sort
  resetSort: () => void
  isDefaultSort: () => boolean
}

export const useShipmentListSort = (initialValues?: Partial<SortValues>): SortState => {
  const sort: Sort = {
    sortBy: useActionableState(initialValues?.sortBy ?? defaultValues.sortBy),
    sortDirection: useActionableState(initialValues?.sortDirection ?? defaultValues.sortDirection),
  }

  const resetSort = () => {
    sort.sortBy.setValue(defaultValues.sortBy)
    sort.sortDirection.setValue(defaultValues.sortDirection)
  }

  const isDefaultSort = (): boolean => {
    const transformActiveSort = mapValues(sort, (sortEntry) => sortEntry.value)
    return isEqual(transformActiveSort, defaultValues)
  }

  return {
    sort,
    resetSort,
    isDefaultSort,
  }
}
